var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPriorityStarNoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.103 1.817a1 1 0 011.794 0l1.81 3.666a1 1 0 00.752.548l4.046.587a1 1 0 01.555 1.706l-2.928 2.854a1 1 0 00-.288.885l.691 4.03a1 1 0 01-1.45 1.054l-3.62-1.902a1 1 0 00-.93 0l-3.62 1.902a1 1 0 01-1.45-1.054l.69-4.03a1 1 0 00-.287-.885L1.94 8.324a1 1 0 01.555-1.706l4.046-.587a1 1 0 00.753-.548l1.81-3.666z",
    stroke: "#70777E"
  })));
}

export default SvgIconPriorityStarNoFilled;